import { Card } from '@/components/ui/card';
import { TrendingUp, MapPin, DollarSign, Clock, ArrowRight } from 'lucide-react';

const HotMarkets = () => {
  const markets = [
    {
      city: 'Frisco',
      county: 'Collin County',
      median_price: 585000,
      growth: '+8.2%',
      days_on_market: 28,
      highlight: 'Fastest Growing',
    },
    {
      city: 'Plano',
      county: 'Collin County',
      median_price: 475000,
      growth: '+5.1%',
      days_on_market: 32,
      highlight: 'Most Popular',
    },
    {
      city: 'McKinney',
      county: 'Collin County',
      median_price: 425000,
      growth: '+6.8%',
      days_on_market: 35,
      highlight: 'Hot Market',
    },
    {
      city: 'Arlington',
      county: 'Tarrant County',
      median_price: 315000,
      growth: '+4.2%',
      days_on_market: 38,
      highlight: 'Best Value',
    },
    {
      city: 'Mansfield',
      county: 'Tarrant County',
      median_price: 385000,
      growth: '+7.3%',
      days_on_market: 30,
      highlight: 'Family Favorite',
    },
    {
      city: 'Allen',
      county: 'Collin County',
      median_price: 495000,
      growth: '+5.9%',
      days_on_market: 29,
      highlight: 'Top Schools',
    }
  ];

  return (
    <div className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display' }}>
            Hot Real Estate Markets in Dallas-Fort Worth
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Discover the fastest-growing Texas neighborhoods and best FSBO opportunities in DFW
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {markets.map((market, idx) => (
            <Card
              key={idx}
              data-testid={`hot-market-card-${market.city.toLowerCase()}`}
              className="relative overflow-hidden hover:shadow-lg transition-all duration-300 border border-gray-200 bg-white"
            >
              {/* Highlight Badge */}
              <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                {market.highlight}
              </div>

              <div className="p-5">
                <div className="mb-4 pr-24">
                  <h3 className="text-xl font-bold text-gray-900">{market.city}</h3>
                  <p className="text-sm text-gray-500 flex items-center mt-0.5">
                    <MapPin className="w-3.5 h-3.5 mr-1 text-orange-400 flex-shrink-0" />
                    {market.county}
                  </p>
                </div>

                <div className="space-y-2.5 text-sm">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500 flex items-center">
                      <DollarSign className="w-4 h-4 mr-1.5 text-gray-400" />
                      Median Price
                    </span>
                    <span className="font-bold text-gray-900">
                      ${market.median_price.toLocaleString()}
                    </span>
                  </div>

                  <div className="flex items-center justify-between">
                    <span className="text-gray-500 flex items-center">
                      <TrendingUp className="w-4 h-4 mr-1.5 text-gray-400" />
                      Growth (YoY)
                    </span>
                    <span className="font-bold text-green-600">{market.growth}</span>
                  </div>

                  <div className="flex items-center justify-between">
                    <span className="text-gray-500 flex items-center">
                      <Clock className="w-4 h-4 mr-1.5 text-gray-400" />
                      Avg Days on Market
                    </span>
                    <span className="font-semibold text-gray-700">{market.days_on_market} days</span>
                  </div>

                  <div className="flex items-center justify-between bg-green-50 rounded-md px-3 py-2 mt-1">
                    <span className="text-green-700 font-medium">List Here FREE</span>
                    <span className="font-bold text-green-600">$0 Fee!</span>
                  </div>
                </div>

                <a
                  href={`/search?city=${market.city}`}
                  data-testid={`view-listings-${market.city.toLowerCase()}`}
                  className="w-full mt-4 bg-[#1E3A5F] hover:bg-[#2a4d7a] text-white py-2.5 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                >
                  View Listings <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotMarkets;
